<template>
  <div>
    <div class="j-range-header"></div>
    <div class="j-range-calendar">
      <div>
        <DatePicker
          is-start
          :is-future-date-disabled="isFutureDateDisabled"
          :range-is-same-month="rangeIsSameMonth"
          :select-date-range="clickedDateRange.length ? clickedDateRange : selectedRange"
          @click:date="selectDate"
        />
      </div>
      <div v-if="isSameMonthinDate(selectedRange)" class="hidden xl:block">
        <DatePicker
          :range-is-same-month="rangeIsSameMonth"
          :is-future-date-disabled="isFutureDateDisabled"
          :select-date-range="clickedDateRange.length ? clickedDateRange : selectedRange"
          @click:date="selectDate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { isSameMonthinDate } from '@src/utils/moment.util.js'
import { isSameMonth } from '../utils/utils'
import DatePicker from './DateRangePickerCalender.vue'

export default {
  name: 'DateRangePicker',
  components: { DatePicker },
  props: {
    selectedRange: {
      type: Array,
      default: () => [],
    },
    isFutureDateDisabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['range:selected'],

  data() {
    return {
      clickedDateRange: [],
      rangeIsSameMonth: true,
    }
  },
  computed: {},

  watch: {
    selectedRange: {
      immediate: true,
      deep: true,
      handler(range) {
        if (range.length === 2) {
          if (isSameMonth(range[0].date, range[1].date)) {
            this.rangeIsSameMonth = true
          } else {
            this.rangeIsSameMonth = false
          }
        }
      },
    },
  },

  methods: {
    isSameMonthinDate,
    selectDate(clickedDate) {
      var currentClickedDate = {
        date: clickedDate.date,
        stateOfCalendar: clickedDate.stateOfCalendar,
        start: clickedDate.start,
      }

      var nextClickedDate = {
        date: clickedDate.nextDate,
        stateOfCalendar: clickedDate.nextStateOfCalendar,
        start: clickedDate.start,
      }

      this.clickedDateRange[0] = currentClickedDate
      this.clickedDateRange[1] = nextClickedDate

      this.$emit('range:selected', this.clickedDateRange)
      this.clickedDateRange = []
    },
  },
}
</script>

<style lang="scss" scoped>
.j-range-calendar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 26px;
}

.j-range-calendar div div.day {
  width: 32px;
  height: 32px;
}
</style>
